import { render, staticRenderFns } from "./Assinante.vue?vue&type=template&id=0e352a40&scoped=true&"
import script from "./Assinante.vue?vue&type=script&lang=js&"
export * from "./Assinante.vue?vue&type=script&lang=js&"
import style0 from "./Assinante.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Assinante.vue?vue&type=style&index=1&id=0e352a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e352a40",
  null
  
)

export default component.exports